import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ChatState {
    userName: string;
    conversationId: number
}

const initialState: ChatState = {
    userName: '',
    conversationId: 0
};

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {

        setUserName: (state, { payload }: PayloadAction<string>) => ({
            ...state,
            userName: payload,
        }),

        setConversationId: (state, { payload }: PayloadAction<number>) => ({
            ...state,
            conversationId: payload,
        }),



    },
});

export const {
    setUserName,
    setConversationId
} = chatSlice.actions;

export default chatSlice.reducer;
